"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const qs_1 = __importDefault(require("qs"));
const FormData_1 = require("./FormData");
const RestException_1 = __importDefault(require("./RestException"));
const version = '1.3.0';
class Rest {
    constructor(options) {
        var _a, _b, _c, _d, _e;
        this.server = (_a = options.server) !== null && _a !== void 0 ? _a : Rest.sandboxServer;
        this.clientId = (_b = options.clientId) !== null && _b !== void 0 ? _b : '';
        this.clientSecret = options.clientSecret;
        this.token = (_c = options.token) !== null && _c !== void 0 ? _c : undefined;
        this.appName = (_d = options.appName) !== null && _d !== void 0 ? _d : 'Unknown';
        this.appVersion = (_e = options.appVersion) !== null && _e !== void 0 ? _e : '0.0.1';
        this.httpClient = axios_1.default.create({
            headers: {
                'X-User-Agent': `${this.appName}/${this.appVersion} ringcentral-extensible/core/${version}`,
            },
            validateStatus: () => true,
            paramsSerializer: {
                serialize: (params) => qs_1.default.stringify(params, { arrayFormat: 'repeat' }),
            },
        });
        this.httpClient.interceptors.request.use((config) => {
            if (Buffer.isBuffer(config.data)) {
                return {
                    ...config,
                    headers: { ...config.headers, 'Content-Type': `multipart/form-data; boundary=${FormData_1.boundary}` },
                };
            }
            return config;
        });
    }
    async request(method, endpoint, content, queryParams, config) {
        var _a;
        const newConfig = {
            baseURL: this.server,
            method,
            url: endpoint,
            data: content,
            params: queryParams,
            ...config,
        };
        // /restapi/oauth/wstoken uses bearer token
        if (endpoint === '/restapi/oauth/token'
            || endpoint === '/restapi/oauth/revoke') {
            if (this.clientSecret) {
                // basic token
                newConfig.auth = {
                    username: this.clientId,
                    password: this.clientSecret,
                };
            }
            // else: PKCE: https://medium.com/ringcentral-developers/use-authorization-code-pkce-for-ringcentral-api-in-client-app-e9108f04b5f0
            newConfig.data = qs_1.default.stringify(newConfig.data);
        }
        else {
            // bearer token
            newConfig.headers = {
                ...newConfig.headers,
                Authorization: `Bearer ${(_a = this.token) === null || _a === void 0 ? void 0 : _a.access_token}`,
            };
        }
        const r = await this.httpClient.request(newConfig);
        if (r.status >= 200 && r.status < 300) {
            return r;
        }
        throw new RestException_1.default(r);
    }
}
Rest.sandboxServer = 'https://platform.devtest.ringcentral.com';
Rest.productionServer = 'https://platform.ringcentral.com';
exports.default = Rest;
//# sourceMappingURL=Rest.js.map